import React, { useState, useEffect } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
    Pagination,
    Box,
    Typography
} from '@mui/material';
import colors from "../theme/Colors";
import { api } from '../helpers/apiRequest';
import CustomSelect from './CustomSelect';
import { format } from 'date-fns';


const PackingTable = ({ userInfo, handleReceiveStockAndPlaceOrder, handleReceiveStock, refreshTable, setRefreshTable, packingData: initialPackingData }) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [packingData, setPackingData] = useState(initialPackingData || []);
    const [totalPages, setTotalPages] = useState(1);
    const sizes = ['XS','S', 'M', 'L', 'XL', '2XL','3XL', 'MIX'];
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const getApiEndpoint = () => {
        switch (userInfo?.role) {
            case 'admin':
                return `/inventory/packing-list`;
            case 'customer':
                return `/inventory/packing-list/customer/${userInfo?.id}`;
            case 'merchant':
                return `/inventory/packing-list/merchant/${userInfo?.id}`;
            default:
                return null;
        }
    };

    const fetchPackingData = async () => {
        if (initialPackingData) {
            setPackingData(initialPackingData);
            return;
        }

        try {
            const endpoint = getApiEndpoint();
            if (!endpoint) return;

            const response = await api.get(
                `${endpoint}?page=${page + 1}&limit=${rowsPerPage}`
            );
            setPackingData(response.data.data);
            setTotalPages(Math.ceil(response.data.total_count / rowsPerPage));
            setRefreshTable(false);
        } catch (error) {
            console.error('Error fetching packing list:', error);
        }
    };

    useEffect(() => {
        fetchPackingData();
    }, [page, rowsPerPage, refreshTable, initialPackingData]);


    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        return format(new Date(dateString), 'MM/dd/yyyy');
    };
    const headerCell = {
        border: '1px solid black',
        padding: '8px',
        backgroundColor: colors.primary,
        fontWeight: 'bold',
        textAlign: 'center'
      };
      
    return (
        <>
            <TableContainer sx={{ marginBottom: 2 }}>
                <Box sx={{ display: 'flex', gap: 2, mt: 2, mb: 4, alignItems: 'center', justifyContent: 'flex-end' }}>
                    {(userInfo?.role === 'admin' && packingData[0]?.status !== 'RECEIVED') &&
                        <Button
                            variant="contained"
                            sx=
                            {{ backgroundColor: colors.primary }}
                            onClick={() => handleReceiveStock(packingData[0]?._id)}
                        >
                            Receive Stock
                        </Button>
                    }
                    {(userInfo?.role === 'admin' && packingData[0]?.status !== 'RECEIVED') && <Button
                        variant="contained"

                        sx=
                        {{ backgroundColor: colors.primary }}
                        onClick={() => handleReceiveStockAndPlaceOrder(packingData[0]?._id)}
                    >
                        Create Order Form
                    </Button>
                    }
                </Box>
                <Table>
                    <TableHead>
                        {packingData.map((row) => (
                            <React.Fragment key={row._id}>
                                <TableRow>
                                    <TableCell
                                        sx={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            backgroundColor: colors.primary,
                                            fontWeight: 'bold',
                                            width: '100px'
                                        }}
                                    >
                                        PARTY
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            backgroundColor: '#f5f5f5',
                                            width: '100px'
                                        }}
                                    >
                                        {row.party?.name}
                                    </TableCell>
                                    <TableCell colSpan={6} sx={{ backgroundColor: '#f5f5f5', border: 'none' }}></TableCell>
                                    <TableCell
                                        sx={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            backgroundColor: colors.primary,
                                            fontWeight: 'bold',
                                            width: '100px'
                                        }}
                                    >
                                        EX FACTORY
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            backgroundColor: '#f5f5f5',
                                            width: '100px'
                                        }}
                                    >
                                        {formatDate(row.ex_factory)}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell
                                        sx={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            backgroundColor: colors.primary,
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        LOT
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            backgroundColor: '#f5f5f5'
                                        }}
                                    >
                                        {row.lot}
                                    </TableCell>
                                    <TableCell colSpan={2} sx={{ backgroundColor: '#f5f5f5', border: 'none' }}></TableCell>
                                    <TableCell
                                        colSpan={2}
                                        align="center"
                                        sx={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            backgroundColor: '#f5f5f5',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        PACKING LIST
                                    </TableCell>
                                    <TableCell colSpan={2} sx={{ backgroundColor: '#f5f5f5', border: 'none' }}></TableCell>
                                    <TableCell
                                        sx={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            backgroundColor: colors.primary,
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        SHIP DATE
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            backgroundColor: '#f5f5f5'
                                        }}
                                    >
                                        {formatDate(row.ship_date)}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell
                                        sx={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            backgroundColor: colors.primary,
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        CONTAINER
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            backgroundColor: '#f5f5f5'
                                        }}
                                    >
                                        {row.container}
                                    </TableCell>
                                    <TableCell colSpan={6} sx={{ backgroundColor: '#f5f5f5', border: 'none' }}></TableCell>
                                    <TableCell
                                        sx={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            backgroundColor: colors.primary,
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        ARRIVAL
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            backgroundColor: '#f5f5f5'
                                        }}
                                    >
                                        {formatDate(row.arrival)}
                                    </TableCell>
                                </TableRow>
                            </React.Fragment>
                        ))}
                    </TableHead>
                </Table>
            </TableContainer>

            <TableContainer >
                <Table>
                    {/* <TableHead>
                        <TableRow>
                            {['Party', 'P Style', 'Order No', 'Item', 'Color', 'XS','S', 'M', 'L', 'XL', '2XL','3XL', 'MIX', 'TOTAL PIECES', 'PER BOX', 'TOTAL BOX'].map((header, index) => (
                                <TableCell
                                    key={index}
                                    sx={{
                                        border: '1px solid black',
                                        padding: '8px',
                                        backgroundColor: colors.primary,
                                        fontWeight: 'bold',
                                        textAlign: 'center'
                                    }}
                                >
                                    {header}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead> */}
                    <TableHead>
  {/* First Row */}
  <TableRow>
    <TableCell rowSpan={2} sx={headerCell}>Party</TableCell>
    <TableCell rowSpan={2} sx={headerCell}>P Style</TableCell>
    <TableCell rowSpan={2} sx={headerCell}>Order No</TableCell>
    <TableCell rowSpan={2} sx={headerCell}>Item</TableCell>
    <TableCell rowSpan={2} sx={headerCell}>Color</TableCell>
    <TableCell rowSpan={2} sx={headerCell}>XS</TableCell>

    {/* S, M, L group with subheaders */}
    <TableCell colSpan={1} sx={headerCell}>S</TableCell>
    <TableCell colSpan={1} sx={headerCell}>M</TableCell>
    <TableCell colSpan={1} sx={headerCell}>L</TableCell>

    <TableCell rowSpan={2} sx={headerCell}>XL</TableCell>
    <TableCell rowSpan={2} sx={headerCell}>2XL</TableCell>
    <TableCell rowSpan={2} sx={headerCell}>3XL</TableCell>
    <TableCell rowSpan={2} sx={headerCell}>MIX</TableCell>
    <TableCell rowSpan={2} sx={headerCell}>TOTAL PIECES</TableCell>
    <TableCell rowSpan={2} sx={headerCell}>PER BOX</TableCell>
    <TableCell rowSpan={2} sx={headerCell}>TOTAL BOX</TableCell>
  </TableRow>

  {/* Second Row (Subheaders) */}
  <TableRow>
    <TableCell sx={headerCell}>(6M/2Y)</TableCell>
    <TableCell sx={headerCell}>(12M/4Y)</TableCell>
    <TableCell sx={headerCell}>(12M/6Y)</TableCell>
  </TableRow>
</TableHead>

                    <TableBody>
                        {packingData.map((row) => (
                            row.items.map((item, index) => (
                                <TableRow key={item._id}>
                                    <TableCell sx={{ border: '1px solid black', textAlign: 'center', minWidth: '60px' }}>
                                        {row?.party?.name}
                                    </TableCell>
                                    <TableCell sx={{ border: '1px solid black', textAlign: 'center', minWidth: '60px' }}>
                                        {item?.p_style?.name}
                                    </TableCell>
                                    <TableCell sx={{ border: '1px solid black', textAlign: 'center', minWidth: '60px' }}>
                                        {item?.order_no}
                                    </TableCell>
                                    <TableCell sx={{ border: '1px solid black', textAlign: 'center', minWidth: '150px' }}>
                                        {item?.item?.name}
                                    </TableCell>
                                    <TableCell sx={{ border: '1px solid black', textAlign: 'center' }}>
                                        {item?.color}
                                    </TableCell>
                                    <TableCell sx={{ border: '1px solid black', textAlign: 'center' }}>
                                        {item?.sizes.find(s => s.size === 'XS')?.quantity || 0}
                                    </TableCell>
                                    <TableCell sx={{ border: '1px solid black', textAlign: 'center' }}>
                                        {item?.sizes.find(s => s.size === 'S')?.quantity || 0}
                                    </TableCell>
                                    <TableCell sx={{ border: '1px solid black', textAlign: 'center' }}>
                                        {item?.sizes?.find(s => s.size === 'M')?.quantity || 0}
                                    </TableCell>
                                    <TableCell sx={{ border: '1px solid black', textAlign: 'center' }}>
                                        {item?.sizes?.find(s => s?.size === 'L')?.quantity || 0}
                                    </TableCell>
                                    <TableCell sx={{ border: '1px solid black', textAlign: 'center' }}>
                                        {item?.sizes?.find(s => s.size === 'XL')?.quantity || 0}
                                    </TableCell>
                                    <TableCell sx={{ border: '1px solid black', textAlign: 'center' }}>
                                        {item?.sizes?.find(s => s.size === '2XL')?.quantity || 0}
                                    </TableCell>
                                    <TableCell sx={{ border: '1px solid black', textAlign: 'center' }}>
                                        {item?.sizes?.find(s => s.size === '3XL')?.quantity || 0}
                                    </TableCell>
                                    <TableCell sx={{ border: '1px solid black', textAlign: 'center' }}>
                                        {item?.sizes?.find(s => s.size === 'MIX')?.quantity || 0}
                                    </TableCell>
                                    {/* {sizes.map(size => (
                                        <TableCell
                                            key={size}
                                            sx={{ border: '1px solid black', textAlign: 'center' }}
                                        >
                                            {item?.sizes?.find(s => s.size === size)?.quantity || 0}
                                        </TableCell>
                                    ))} */}
                                    <TableCell sx={{ border: '1px solid black', textAlign: 'center' }}>
                                        {item?.total_pieces}
                                    </TableCell>
                                    <TableCell sx={{ border: '1px solid black', textAlign: 'center' }}>
                                        {item?.per_box}
                                    </TableCell>
                                    <TableCell sx={{ border: '1px solid black', textAlign: 'center' }}>
                                        {item?.total_box}
                                    </TableCell>
                                </TableRow>
                            ))
                        ))}
                    </TableBody>
                </Table>
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, mb: 2, alignItems: 'center', gap: 2 }}>
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        showFirstButton
                        showLastButton
                    />
                    <CustomSelect
                        label="Rows per page"
                        value={rowsPerPage}
                        onChange={handleChangeRowsPerPage}
                        options={[
                            // { id: 5, name: '5' },
                            // { id: 10, name: '10' },
                            // { id: 25, name: '25' },
                            // { id: 50, name: '50' },
                            { id: 100, name: '100' },
                            { id: 200, name: '200' },
                            { id: 300, name: '300' },
                            { id: 400, name: '400' },
                            { id: 500, name: '500' },
                        ]}
                        sx={{ minWidth: 120 }}
                    />
                </Box>

                {/* Summary Section */}
                <Box sx={{ mt: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, backgroundColor: '#f5f5f5' }}>
                    <Typography variant="h6" sx={{ mb: 2 }}>Packing List Summary</Typography>
                    <Box sx={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                        <Box>
                            <Typography variant="subtitle2" color="text.secondary">Total Pieces</Typography>
                            <Typography variant="h6">
                                {packingData?.reduce((sum, row) =>
                                    sum + row?.items?.reduce((itemSum, item) => itemSum + (item.total_pieces || 0), 0), 0)}
                            </Typography>
                        </Box>
                        <Box>
                            <Typography variant="subtitle2" color="text.secondary">Total Boxes</Typography>
                            <Typography variant="h6">
                                {packingData.reduce((sum, row) =>
                                    sum + row?.items?.reduce((itemSum, item) => itemSum + (item.total_box || 0), 0), 0)}
                            </Typography>
                        </Box>
                        {sizes?.map(size => (
                            <Box key={size}>
                                <Typography variant="subtitle2" color="text.secondary">Total {size}</Typography>
                                <Typography variant="h6">
                                    {packingData?.reduce((sum, row) =>
                                        sum + row?.items?.reduce((itemSum, item) => {
                                            const sizeData = item?.sizes?.find(s => s?.size === size);
                                            return itemSum + (sizeData?.quantity || 0);
                                        }, 0), 0)}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>

            </TableContainer>
        </>
    );
};

export default PackingTable;
